
import ForgotPasswordForm from "@/components/auth/components/ForgotPasswordForm";

const LOGO = "https://cdn.tranzytours.com/assets/branding/logo.png";

export default function ForgotPassword() {
  return (
    <div className="min-h-screen bg-[#0ea5e9]/85 md:bg-[#0ea5e9] relative overflow-hidden">
      {/* subtle floating circles */}
      <div className="pointer-events-none absolute -left-10 -top-10 h-40 w-40 rounded-full bg-white/30 blur-md" />
      <div className="pointer-events-none absolute -right-12 bottom-8 h-44 w-44 rounded-full bg-white/30 blur-md" />

      <div className="mx-auto max-w-6xl px-4 py-8 md:py-14">
        <div className="relative mx-auto max-w-md rounded-3xl bg-white shadow-[0_25px_80px_rgba(2,6,23,0.25)] overflow-hidden border border-gray-200">
          {/* card body */}
          <div className="px-8 py-10">
            {/* Logo */}
            <div className="mb-4 flex justify-center">
              <img src={LOGO} alt="Tranzy Tours" className="h-12" />
            </div>

            <h1 className="text-center text-3xl font-bold text-sky-600">Forgot Password</h1>
            <p className="mt-1 text-center text-xs text-gray-500">
              Enter your email and we’ll send you a reset link.
            </p>

            <ForgotPasswordForm />
          </div>

          {/* small bottom accent */}
          <div className="h-2 w-full bg-gradient-to-r from-sky-400 via-sky-500 to-sky-600" />
        </div>
      </div>
    </div>
  );
}
